module.exports = __webpack_public_path__ + "static/media/Test43.4f7100fc.bmp";